import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import SiteLogo from "../../assets/Logo-5.png";

const MobileNavbar = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [openRestaurants, setOpenRestaurants] = useState(false);
  const [openMosques, setOpenMosques] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const toggleRestaurants = () => {
    setOpenRestaurants(!openRestaurants);
  };

  const toggleMosques = () => {
    setOpenMosques(!openMosques);
  };

  const handleClose = () => {
    setDrawerOpen(false);
    setOpenRestaurants(false);
    setOpenMosques(false);
  };

  const navLinks = [
    { to: "/", text: "HOME" },
    {
      to: "/",
      text: "RESTAURANTS",
      toggle: toggleRestaurants,
      open: openRestaurants,
      subLinks: [
        { to: "/restaurants/jp", text: "JAPAN" },
        { to: "/restaurants/sk", text: "SOUTH KOREA" },
        { to: "/restaurants/cand", text: "CANADA" },
      ],
    },
    {
      to: "/",
      text: "MOSQUES",
      toggle: toggleMosques,
      open: openMosques,
      subLinks: [
        { to: "/mosques/jp", text: "JAPAN" },
        { to: "/mosques/sk", text: "SOUTH KOREA" },
        { to: "/mosques/cand", text: "CANADA" },
      ],
    },
    { to: "/numbers", text: "E-NUMBER CHECK" },
    { to: "/about", text: "ABOUT US" },
    { to: "/contact", text: "CONTACT US" },
  ];

  return (
    <div>
      <AppBar position="static" style={{ backgroundColor: "#fff", zIndex: 2 }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="#000"
            aria-label="menu"
            sx={{ mr: 2, zIndex: 2 }}
            onClick={toggleDrawer}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Link to="/">
              <img
                src={SiteLogo}
                alt="Halal World"
                style={{
                  height: "70px",
                  marginRight: "20px",
                }}
              />
            </Link>
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="top"
        open={isDrawerOpen}
        onClose={handleClose}
        BackdropProps={{ invisible: true }}
        sx={{
          "& .MuiDrawer-paper": {
            height: "auto",
            width: "100%",
            maxWidth: "100%",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            marginTop: "4.8rem",
          },
        }}
      >
        <List
          sx={{
            backgroundColor: "#fff",
            color: "#000",
            width: "100%",
            "& .MuiListItem-root": {
              justifyContent: "center",
              paddingLeft: "16px",
              paddingRight: "16px",
            },
            "& .MuiListItemText-root": {
              textAlign: "center",
              margin: 0,
            },
          }}
        >
          {navLinks.map((link) => (
            <React.Fragment key={link.text}>
              {link.subLinks ? (
                <React.Fragment>
                  <ListItem
                    button
                    onClick={link.toggle}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <ListItemText primary={link.text} />
                    {link.open ? (
                      <ExpandLess
                        sx={{ position: "absolute", right: "16px" }}
                      />
                    ) : (
                      <ExpandMore
                        sx={{ position: "absolute", right: "16px" }}
                      />
                    )}
                  </ListItem>
                  <Collapse in={link.open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {link.subLinks.map((subLink) => (
                        <ListItem
                          key={subLink.to}
                          button
                          component={Link}
                          to={subLink.to}
                          onClick={handleClose}
                        >
                          <ListItemText primary={subLink.text} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </React.Fragment>
              ) : (
                <ListItem
                  button
                  onClick={handleClose}
                  component={Link}
                  to={link.to}
                >
                  <ListItemText primary={link.text} />
                </ListItem>
              )}
            </React.Fragment>
          ))}
        </List>
      </Drawer>
    </div>
  );
};

export default MobileNavbar;
